import React from "react";
import { useDemoAccess } from "@/hooks/use-demo-access";
import { NavigationMenuProps } from "./Sidebar.const";
import { Link, useLocation } from "react-router";

function classNames(...classes: (string | undefined | null)[]): string {
  return classes.filter(Boolean).join(" ");
}

export const NavigationMenuList: React.FC<{ navigation: NavigationMenuProps }> = ({ navigation }) => {
  const { pathname } = useLocation();
  const { hasFeature } = useDemoAccess();

  const filteredNavigation = navigation.filter(item => !item.requiredFeature || hasFeature(item.requiredFeature));

  const updatedNavigation = filteredNavigation.map(item => ({
    ...item,
    current: pathname === item.href,
    children: item.children
      ?.filter(subItem => !subItem.requiredFeature || hasFeature(subItem.requiredFeature))
      .map(subItem => ({
        ...subItem,
        current: pathname === subItem.href,
      })),
  }));

  return (
    <nav className="mt-8 rounded-lg text-sm text-ui-sidebar-text">
      {updatedNavigation.map(item => (
        <div key={item.name} className="mb-1">
          {item.href ? (
            <Link
              to={item.href}
              className={classNames(
                item.current
                  ? "bg-ui-sidebar-text text-white"
                  : "text-atriablue-500 hover:bg-white hover:text-gray-600",
                "flex items-center gap-2 rounded-md px-2 py-1.5 transition-colors duration-200 ease-in-out",
              )}
            >
              {item.icon && <item.icon className="h-5 w-5 shrink-0" aria-hidden="true" />}
              <span className="flex-1 text-sm">{item.name}</span>
            </Link>
          ) : (
            <span
              className={classNames(item.current ? "text-white" : "text-white", "flex items-center gap-2 px-2 py-1.5")}
            >
              {item.icon && <item.icon className="h-5 w-5 shrink-0" aria-hidden="true" />}
              <span className="flex-1 text-sm">{item.name}</span>
            </span>
          )}
          {item.children && (
            <div className="pl-3">
              {item.children.map(subItem =>
                subItem.href ? (
                  <Link
                    key={subItem.name}
                    to={subItem.href}
                    className={classNames(
                      subItem.current ? "text-white" : "text-gray-400",
                      "flex items-center gap-2 rounded-md px-2 py-1.5 transition-colors duration-200 ease-in-out hover:bg-gray-800 hover:text-white",
                    )}
                  >
                    {subItem.icon && <subItem.icon className="h-4 w-4 shrink-0" aria-hidden="true" />}
                    <span className="flex-1 text-xs">{subItem.name}</span>
                  </Link>
                ) : (
                  <span
                    key={subItem.name}
                    className={classNames(
                      subItem.current ? "text-white" : "text-gray-400",
                      "flex items-center gap-2 px-2 py-1.5",
                    )}
                  >
                    {subItem.icon && <subItem.icon className="h-4 w-4 shrink-0" aria-hidden="true" />}
                    <span className="flex-1 text-xs">{subItem.name}</span>
                  </span>
                ),
              )}
            </div>
          )}
        </div>
      ))}
    </nav>
  );
};
